import { render } from "./SubtitleElement.vue?vue&type=template&id=2cac306e&scoped=true"
import script from "./SubtitleElement.vue?vue&type=script&lang=ts"
export * from "./SubtitleElement.vue?vue&type=script&lang=ts"

import "./SubtitleElement.vue?vue&type=style&index=0&id=2cac306e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cac306e"

export default script